/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Auto_HintInputs */

const vi_einvoice_auto_hint = /** @type {(inputs: Einvoice_Auto_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hệ thống tự động xuất sau khi thanh toán`)
};

/**

* @param {Einvoice_Auto_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_auto_hint = /** @type {((inputs?: Einvoice_Auto_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Auto_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_auto_hint(inputs)
});